<svg viewBox="0 0 151 150" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="3.12222" y1="3.24838" x2="147.295" y2="147.421" stroke="black" stroke-width="4"/>
<path d="M1.88239 108.092L41.967 148.177" stroke="black" stroke-width="4"/>
<path d="M148.449 41.9072L108.364 1.82273" stroke="black" stroke-width="4"/>
<path d="M1.61981 133.588L16.1371 148.106" stroke="black" stroke-width="4"/>
<path d="M148.712 16.4111L134.194 1.89376" stroke="black" stroke-width="4"/>
<line x1="2.41434" y1="83.2474" x2="67.4922" y2="148.325" stroke="black" stroke-width="4"/>
<line x1="147.917" y1="66.7516" x2="82.8391" y2="1.67374" stroke="black" stroke-width="4"/>
<line x1="2.41421" y1="56.3451" x2="93.5232" y2="147.454" stroke="black" stroke-width="4"/>
<line x1="147.917" y1="93.6544" x2="56.8079" y2="2.54541" stroke="black" stroke-width="4"/>
<line x1="2.41434" y1="29.4427" x2="121.557" y2="148.585" stroke="black" stroke-width="4"/>
<line x1="147.917" y1="120.557" x2="28.7744" y2="1.41421" stroke="black" stroke-width="4"/>
</svg>
